import { call, put } from "redux-saga/effects";

import Api from "common/api";
import constants from "./constants";
import moment from "moment";

export default {
  GetOpportunityList: function* (data) {
    const __name = constants.OPPORTUNITY_LIST;
    try {
      const res = yield call(Api.getOpportunityList, data.cusId, moment().format("YYYY-MM-DD"));
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  GetLowPerformanceKeywords: function* (data) {
    const __name = constants.LOW_PERFORMANCE_KEYWORDS;
    try {
      const res = yield call(Api.getLowPerformanceKeywords, data.cusId, data.date);
      //console.log("GetLowPerformanceKeywords", res)
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
};
